import { debounce, throttle } from 'lodash'

const useDebounce = () => {
  const landDebounce = (callback: (...params: any) => void, ms = 300) => {
    return debounce(callback, ms)
  }

  const landThrottle = (callback: (...params: any) => void, ms = 300) => {
    return throttle(callback, ms)
  }

  return { landDebounce, landThrottle }
}
export default useDebounce
